export const isFullUrl = (url: string | undefined): boolean => {
  if (!url) return false

  const urlPattern = /^(?:\w+:)?\/\/(\S+)$/

  return urlPattern.test(url)
}

// True when the `redirect` query param points outside the app (e.g. the community site),
// so post-login navigation has to leave the SPA instead of pushing a route
export const hasExternalRedirect = (search: string | undefined): boolean =>
  isFullUrl(new URLSearchParams(search).get('redirect') || undefined)
